<template>
  <div v-show="componentsReady">
    <div class="section">
      <div class="columns is-centered">
        <div class="column is-11">
          <validation-observer
            ref="profile-fields"
            tag="form"
          >
            <profile
              v-bind="profileInfo"
              @profile="filingProfile = $event"
              @profileReady="profileReady = $event"
            />
          </validation-observer>
          <positions
            v-bind="{ type: 'filing' }"
            @positions="positions = $event"
            @hasPositions="hasPositions = $event"
            @hasPrimaryPosition="hasPrimaryPosition = $event"
            @hasPositionsReady="hasPositionsReady = $event"
          />
          <!-- <validation-observer
            ref="private-business-fields"
            tag="form"
          >
            <private-business
              @privateBusiness="privateBusiness = $event"
              @privateBusinessReady="privateBusinessReady = $event"
            />
          </validation-observer> -->
          <validation-observer
            ref="filer-status-fields"
            tag="form"
          >
            <filer-status
              @filerStatuses="filerStatuses = $event"
              @filerStatusesReady="filerStatusesReady = $event"
            />
          </validation-observer>
          <div class="columns">
            <div class="column has-text-centered">
              <button
                id="save-btn"
                type="button"
                class="button is-primary"
                :class="isSaving ? 'is-loading' : ''"
                :disabled="isSaving"
                @click="saveAndContinue"
              >
                Save and Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Profile from '@/components/Profile';
import Positions from '@/components/Positions';
// import PrivateBusiness from '@/components/PrivateBusiness';
import FilerStatus from '@/components/FilerStatus';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';

export default {
  name: 'User',
  components: {
    Profile,
    Positions,
    // PrivateBusiness,
    FilerStatus,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      profileInfo: {
        type: 'filing',
        formTitle: 'Filer Information',
        formDesc: 'Do not include anything that bears your Social Security Number or financial account numbers.',
      },
      filerStatuses: [],
      filingProfile: {},
      isSaving: false,
      positions: [],
      hasPositions: false,
      // privateBusiness: {},
      profileReady: false,
      hasPositionsReady: false,
      hasPrimaryPosition: true,
      // privateBusinessReady: false,
      filerStatusesReady: false,
    };
  },
  computed: {
    componentsReady() {
      if (this.profileReady && this.hasPositionsReady && this.filerStatusesReady) {
        this.$store.commit('loading', false);
        return true;
      }
      return false;
    },
  },
  methods: {
    async saveAndContinue () {
      let isValidProfile = await this.$refs['profile-fields'].validate();
      let isValidFilerStatus = await this.$refs['filer-status-fields'].validate();
      // let isValidPrivateBusiness = await this.$refs['private-business-fields'].validate();

      this.isSaving = true;

      if (
        !isValidProfile ||
        !isValidFilerStatus ||
        // !isValidPrivateBusiness ||
        !this.hasPositions ||
        !this.hasPrimaryPosition
      ) {
        let warnings = [];
        warnings.push("There are some validation issues.");
        if (!this.hasPrimaryPosition) {
          warnings.push("You must have 1 primary position. Edit the primary position (which you currently hold) and check the \"Primary Position\" box.");
        }
        warnings.push("Please review your information and try again.");
        this.$warning(warnings.join(' '));
        this.isSaving = false;
        return false;
      }

      this.filingProfile.enterFilerInfoCompleted = 'Y';

      let filing = { ...this.filingProfile };

      let promises = [];

      promises.push(this.$store.dispatch('filing/saveFiling', filing));
      promises.push(this.$store.dispatch('filing/saveFilingScreen', {
        items: this.positions,
        endpoint: 'positions',
      }));
      promises.push(this.$store.dispatch('filing/saveFilingFilerStatuses', this.filerStatuses));

      Promise.all(promises).then(() => {
        this.isSaving = false;
        this.$router.push({ name: this.nextFilingScreen });
      });

    },
  },
};
</script>
